export default __webpack_public_path__ + "static/media/Calendar-VGL-icon.629b86a5.png";